import React, { useEffect, useRef, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { tr } from "../contexts/LangContext";
import api, { formatApiErrorDetail } from "../lib/api";
import { Check, X } from "lucide-react";

export default function VerifyEmail() {
  const [params] = useSearchParams();
  const [state, setState] = useState("loading");
  const [msg, setMsg] = useState("");
  const ran = useRef(false);

  useEffect(() => {
    if (ran.current) return;
    ran.current = true;
    const token = params.get("token") || "";
    (async () => {
      try {
        const { data } = await api.post("/auth/verify-email", { token });
        setState("ok");
        setMsg(data.message);
      } catch (e) {
        setState("err");
        setMsg(formatApiErrorDetail(e.response?.data?.detail) || tr("Lien invalide ou déjà utilisé"));
      }
    })();
  }, [params]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-sand px-6 pt-20" data-testid="verify-email-page">
      <div className="bg-white border border-slate-200 p-10 max-w-md w-full text-center">
        {state === "loading" && <p className="text-slate-500">{tr("Chargement…")}</p>}
        {state === "ok" && (
          <>
            <Check className="w-10 h-10 text-green-600 mx-auto mb-4" />
            <h1 className="font-serif text-2xl text-navy mb-3">{tr("Adresse confirmée")}</h1>
            <p className="text-sm text-slate-600" data-testid="verify-success">{msg}</p>
          </>
        )}
        {state === "err" && (
          <>
            <X className="w-10 h-10 text-red-600 mx-auto mb-4" />
            <h1 className="font-serif text-2xl text-navy mb-3">{tr("Vérification impossible")}</h1>
            <p className="text-sm text-red-600" data-testid="verify-error">{msg}</p>
          </>
        )}
        <Link to="/login" className="inline-block mt-6 text-xs uppercase tracking-[0.2em] text-club-red underline underline-offset-4" data-testid="verify-login-link">
          {tr("Se connecter")}
        </Link>
      </div>
    </div>
  );
}
